import { IconProps } from "../../types/utils";

const Female = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2625 24.5629V26.812C14.2625 27.4229 14.7622 27.9226 15.3731 27.9226C15.984 27.9226 16.4837 27.4229 16.4837 26.812V24.5629H19.2605C19.8714 24.5629 20.3711 24.0631 20.3711 23.4522C20.3711 22.8414 19.8714 22.3416 19.2605 22.3416H16.4837V20.0925C20.5379 19.5093 23.3424 15.7608 22.787 11.7066C22.1761 7.65243 18.4553 4.84798 14.3734 5.40334C10.3192 5.98656 7.51473 9.73506 8.07009 13.7892C8.51442 17.0103 11.0134 19.5371 14.2345 20.0647V22.3418H11.7076C11.0967 22.3418 10.597 22.8415 10.597 23.4524C10.597 24.0633 11.0967 24.563 11.7076 24.563L14.2625 24.5629ZM10.2916 12.7616C10.2916 9.90147 12.5963 7.56898 15.4842 7.56898C18.3721 7.56898 20.7045 9.8737 20.7045 12.7338C20.7045 15.5939 18.3998 17.9264 15.512 17.9264H15.4843C12.6242 17.9541 10.2917 15.6216 10.2639 12.7616V12.7339L10.2916 12.7616Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Female;
